import { createAction } from "@reduxjs/toolkit";

export interface MenuSelectedAction {
  position: "side" | "top"
  menu: string
}

export const MENU_SELECTED = createAction<MenuSelectedAction>("navigation/menu_selected");